import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ProductContextDisplayProperties } from 'ish-core/facades/product-context.facade';

import { IcmCarousalContentlet } from '../../models/dot-cms-uve-contentlet.model';

import { DotCmsUveProductCarouselListComponent } from './dot-cms-uve-product-carousel-list/dot-cms-uve-product-carousel-list.component';

@Component({
  selector: 'custom-dot-cms-uve-product-carousel',
  templateUrl: './dot-cms-uve-product-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, DotCmsUveProductCarouselListComponent],
})
export class DotCmsUveProductCarouselComponent {
  readonly contentlet = input<IcmCarousalContentlet>(undefined);
  // contentlet$: Observable<CustomDotCmsContentlet>;
  productSKUs: string[] = [];
  displayProperties: Partial<ProductContextDisplayProperties>;
  triggerCount = 1;
  constructor() {} // private gtmFacade: GoogleTagManagerFacade // private elementRef: ElementRef,
}
